export const hasEntries = <T>(entryArray: T[] | null | undefined): boolean =>
  entryArray != null && Boolean(Number(entryArray.length));

export const getEntriesCount = <T>(
  entryArray: T[] | null | undefined,
): number => (entryArray ? Number(entryArray.length) : 0);
